import { ChangeEvent, PropsWithChildren } from 'react';
import classnames from 'classnames';
import { SearchInput } from '@ds';
import { SelectCasesType } from '@lp/features/MultiSuggest/types';
import { ListRules } from './ListRules';

type CaseListWrapperProps = {
  modalContentType: SelectCasesType;
  searchText: string;
  isVisible: boolean;
  casesCount: number;
  onSearchChange: (text: string) => void;
};

export const CaseListWrapper = ({
  modalContentType,
  isVisible,
  casesCount,
  searchText,
  onSearchChange,
  children,
}: PropsWithChildren<CaseListWrapperProps>) => {
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.target.value);
  };

  const isTarget = modalContentType === SelectCasesType.Target;

  return (
    <div key={modalContentType} className={classnames('flex flex-col gap-4 w-full', { hidden: !isVisible })}>
      {!!casesCount && (
        <div className="flex justify-end">
          <div className="w-[256px]">
            <SearchInput placeholder="Search" value={searchText} onChange={handleSearchChange} />
          </div>
        </div>
      )}
      <div
        className={classnames('flex flex-col gap-4 overflow-y-auto max-h-186', { 'mt-13': isTarget && !casesCount })}
      >
        <ListRules key={modalContentType} type={modalContentType} casesCount={casesCount} />
        {children}
      </div>
    </div>
  );
};
